"use client"

import { Box } from "@mui/material"
import RecentLinkHighlighter, { recentLinkHighlighterSx } from "@v2/components/RecentLinkHighlighter"
import { ReactNode } from "react"

export default function PlpRecentProductHighlighter({ children }: { children: ReactNode }) {
    return (
        <RecentLinkHighlighter scope="plp-products" restoreScrollPosition linkSelector="a[data-plp-product-link]">
            {({ ref, onClickCapture }) => (
                <Box
                    ref={ref}
                    onClickCapture={onClickCapture}
                    sx={{ display: 'contents', ...recentLinkHighlighterSx }}
                >
                    {children}
                </Box>
            )}
        </RecentLinkHighlighter>
    )
}
